const parseRecipients = value => (value ? value.split(/[ ,]+/) : []);

export default parseRecipients;
